import { combineReducers } from 'redux';
import { mergeReducers } from 'state/mergeReducers';
import claims from './ClaimsDashboard/state';

export default mergeReducers(
  combineReducers({
    claims
  })
);
